import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeThree/level_one.png'


const _hoisted_1 = {
  key: 0,
  class: "vip-card"
}
const _hoisted_2 = { style: {"color":"goldenrod"} }
const _hoisted_3 = { class: "vip-body" }
const _hoisted_4 = { class: "vip-section" }
const _hoisted_5 = { class: "bar" }
const _hoisted_6 = { style: {"position":"absolute","left":"35%","top":"6%"} }

import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'vipCard',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)

const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_unref(userStore).vipAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_row, { style: {"display":"flex","align-items":"center"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              class: "initRow",
              span: "6"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("img", { src: _imports_0 }, null, -1)
              ])),
              _: 1
            }),
            _createVNode(_component_van_col, { span: "17" }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('vip.follow')) + " ", 1),
                  _createElementVNode("span", _hoisted_2, "VIP" + _toDisplayString(currentLevel.value), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('vip.needToBet')) + " " + _toDisplayString(betMin.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "1",
              onClick: onClickCard
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "20"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('vip.betRequired')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, { span: 18 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(betMin.value + '/' + betTotal.value), 1),
                      _createElementVNode("div", {
                        class: "progress",
                        style: _normalizeStyle({ width: betTotal.value / betMin.value < 1 ? (betTotal.value * 100) / betMin.value + '%' : '100%' })
                      }, null, 4)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})